import { Paperclip } from "lucide-react";
import { useState } from "react";
import { DropzoneOptions } from "react-dropzone";
import { toast } from "sonner";
import Cookies from "js-cookie";

import {
  FileUploader,
  FileUploaderContent,
  FileUploaderItem,
  FileInput,
} from "@/components/extensions/file-upload";
import { Button } from "@/components/ui/button/button";
import { uploadLeadsAsAdmin } from "@/config/mutation/admin/lead";
import { AxiosError } from "axios";

const FileSvgDraw = () => {
  return (
    <>
      <svg
        className="w-8 h-8 mb-3 text-gray-500 dark:text-gray-400"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 20 16"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
        />
      </svg>
      <p className="mb-1 text-sm text-gray-500 dark:text-gray-400">
        <span className="font-semibold">Click to upload</span>
        &nbsp; or drag and drop
      </p>
      <p className="text-xs text-gray-500 dark:text-gray-400">
        XLSX or CSV file only
      </p>
    </>
  );
};

const FileUploaderTest = () => {
  const adminKey = Cookies.get("key") as string;
  const [files, setFiles] = useState<File[] | null>(null);

  const [isUploading, setIsUploading] = useState(false);

  const dropZoneConfig: DropzoneOptions = {
    maxFiles: 1,
    maxSize: 1024 * 1024 * 4,
    multiple: false,
    accept: {
      "text/csv": [".csv"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xlsx",
      ],
    },
  };

  const handleUploadFile = async () => {
    if (files === null || files.length === 0) {
      toast.error("Select a file first!");
      return;
    }

    setIsUploading(true);
    try {
      const response = await uploadLeadsAsAdmin(adminKey)(files[0]);
      console.log("Leads Response", response);
      toast.success(response);
      setFiles(null);
    } catch (error) {
      console.log("ERROR WHILE UPLOADING FILE", error);
      const isAxiosError = error instanceof AxiosError;
      if (isAxiosError) {
        const errorReason = error?.response?.data?.error as string;
        toast.error(errorReason);
      } else {
        // @ts-ignore
        toast.error(error?.message);
      }
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="flex flex-col gap-3">
      <FileUploader
        value={files}
        onValueChange={setFiles}
        dropzoneOptions={dropZoneConfig}
        className="relative bg-background rounded-lg p-2"
      >
        <FileInput className="outline-dashed outline-1 outline-white">
          <div className="flex items-center justify-center flex-col pt-3 pb-4 w-full ">
            <FileSvgDraw />
          </div>
        </FileInput>
        <FileUploaderContent>
          {files &&
            files.length > 0 &&
            files.map((file, i) => (
              <FileUploaderItem key={i} index={i}>
                <Paperclip className="h-4 w-4 stroke-current" />
                <span>{file.name}</span>
              </FileUploaderItem>
            ))}
        </FileUploaderContent>
      </FileUploader>

      <div className="">
        <Button
          type="button"
          className="w-full"
          disabled={files === null || files.length === 0 || isUploading}
          onClick={handleUploadFile}
        >
          Upload
        </Button>
      </div>
    </div>
  );
};

const UploadLeadsForAdmin = () => {
  return (
    <div className="p-5 h-[calc(100%-56px)]">
      <div className="flex items-center justify-between">
        <h3 className="text-2xl font-medium">Upload Leads</h3>
      </div>

      <div className="mt-6 flex items-center justify-center pt-10">
        <div className="max-w-xl w-full">
          <FileUploaderTest />
        </div>
      </div>
    </div>
  );
};

export default UploadLeadsForAdmin;
